import React, { Component } from "react";
import { Api } from "../utils/api";
import Button from "@material-ui/core/Button";
import NewInvoice from "./components/new_invoice.component";
import { withRouter } from "react-router";
import { Grid } from "@material-ui/core";
import AlertDialog from "../components/alert.component";
import CircularProgress from "@material-ui/core/CircularProgress";

class InvoicesView extends Component {
  state = {
    easypayPayment: {},
    clientData: {},
    showAlert: false,
    alertTitle: null,
    alertMessage: null,
    showLoading: false,
  };

  constructor() {
    super();
    this.form = null;
    this.api = new Api();
    this.setForm = this.setForm.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.submit = this.submit.bind(this);
    this.isSubmitting = this.isSubmitting.bind(this);
    this.getEasypayPayment = this.getEasypayPayment.bind(this);
    this.getEasypayReference = this.getEasypayReference.bind(this);
    this.getEntity = this.getEntity.bind(this);
    this.getInvoiceClientData = this.getInvoiceClientData.bind(this);
    this.closeAlert = this.closeAlert.bind(this);
    this.showAlert = this.showAlert.bind(this);
  }

  /**
   *
   */

  componentDidMount() {
    const { id } = this.props.match.params;
    if (id === "new") this.setState({ easypayPayment: {} });
    else {
      this.getEasypayPayment(id).then((data) => {
        this.getEasypayReference(data.easypay_reference_id).then((data) => {
          this.getEntity(data.entity_id).then((data) => {
            this.getInvoiceClientData(data.invoicexpress_client_id);
          });
        });
      });
    }
  }

  /**
   *
   */

  getEasypayPayment(id) {
    return this.api.get(`/easypay_payments/${id}`).then(({ data = null }) => {
      this.setState({ easypayPayment: data });
      return data;
    });
  }

  getEntity(id) {
    return this.api.get(`/entities/${id}`).then(({ data = null }) => {
      return data;
    });
  }

  getEasypayReference(id) {
    return this.api.get(`/easypay_references/${id}`).then(({ data = null }) => {
      return data;
    });
  }

  getInvoiceClientData(id) {
    return this.api
      .get(`/invoicexpress_clients/${id}`)
      .then(({ data = null }) => {
        this.setState({ clientData: data });
      });
  }

  /**
   *
   */

  setForm(form) {
    this.form = form;
  }

  handleSubmit(values, actions) {
    actions.setSubmitting(true);
    this.setState({ showLoading: true });
    return this.api
      .post(`invoicexpress_invoices/`, { ...values })
      .then((res) => {
        this.setState({ showLoading: false });
        actions.setSubmitting(false);
        if (res.status === 201) {
          const invoiceNumber =
            res.data.sequence_number !== "draft"
              ? res.data.sequence_number
              : res.data.id;
          this.showAlert(
            "Sucesso",
            "Fatura " + invoiceNumber + " criada com sucesso"
          );
        } else this.showAlert("Erro", "Ocorreu um erro. Tente novamente.");
      })
      .catch(() => {
        actions.setSubmitting(false);
        this.setState({ showLoading: false });
        this.showAlert("Erro", "Ocorreu um erro. Tente novamente.");
      });
  }

  submit() {
    if (this.form) {
      this.form.submitForm();
    }
  }

  isSubmitting() {
    return this.form ? this.form.isSubmitting : false;
  }

  /**
   *
   */

  /**
   *
   */

  showAlert(title, message) {
    this.setState({ showAlert: true });
    this.setState({ alertTitle: title });
    this.setState({ alertMessage: message });
  }

  closeAlert = () => {
    this.setState({ showAlert: false });
    this.props.history.goBack();
  };

  /**
   *
   */

  render() {
    const payment = this.state.easypayPayment;
    const clientData = this.state.clientData;

    return (
      <>
        <div className="main-reqlist-container">
          <NewInvoice
            onSubmit={this.handleSubmit}
            getForm={this.setForm}
            payment={payment}
            clientData={clientData}
          />

          {clientData && (
            <Grid style={{ textAlign: "right" }}>
              <Button onClick={this.submit} color="primary">
                Criar fatura
              </Button>
            </Grid>
          )}
        </div>
        <AlertDialog
          open={this.state.showAlert}
          handleClose={this.closeAlert}
          title={this.state.alertTitle}
          message={this.state.alertMessage}
        ></AlertDialog>
        {this.state.showLoading && (
          <CircularProgress
            color="secondary"
            style={{ position: "absolute", top: "50%", left: "50%" }}
          />
        )}
      </>
    );
  }
}

export default withRouter(InvoicesView);
